import React, { useEffect, useReducer } from 'react';
import { useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';

import { getChallenges } from '../../actions/challenge-actions';
import ChallengeHolder from './ChallengeHolder';
import CloseChallengeHolder from './CloseChallengeHolder';
import Loading from '../shared/Loading'
import { DefaultLayout, TabsCategory } from '../shared/component'

import { ConvertDateString } from '../../utils/helpers/dateformat/ConvertDateString'
import { getIconChallenge } from '../../utils/helpers/icon/iconHelper';
import ChallengeContext from '../../context/challenge-context'
import { challengeReducer, initialState } from '../../reducers/challenge-reducer'

const Challenge = () => {
    const history = useHistory();
    const [challengeContext, dispatch] = useReducer(challengeReducer, initialState);

    useEffect(() => {
        initChallenge();
    }, []);

    const initChallenge = async () => {
        dispatch({ type: 'SET_LOADING', loading: true });
        const response = await getChallenges();
        dispatch({ type: 'SET_LOADING', loading: false });

        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        if (response.status === "Success") {
            let Challenges = response.data;

            let onGoingChallenges = Challenges.filter((value) => {
                let today = new Date();
                let endDate = new Date(ConvertDateString.convertForDatePicker(value.EndDate));

                if (today <= endDate) {
                    return value;
                }
                else
                    return null;
            });

            let closeChallenges = Challenges.filter((value) => {
                let today = new Date();
                let endDate = new Date(ConvertDateString.convertForDatePicker(value.EndDate));
                if (today > endDate)
                    return value;
                else
                    return null;
            });

            dispatch({ type: 'SET_ONGOING_CHALLENGES', onGoingChallenges: onGoingChallenges });
            dispatch({ type: 'SET_CLOSE_CHALLENGES', closeChallenges: closeChallenges });
        }

    };

    const breadcrumbsData = [
        {
            type: 'Challenge',
            text: 'Challenges',
            href: ''
        },
    ];


    const dataTabsCategory = [
        {
            label: 'On-going',
            component: (
                <Grid>
                    <ChallengeHolder />
                </Grid>
            ),
            description: 'Please select a challenge from the list to begin.',
            type: 'Challenge',
            breadcrumbsData: breadcrumbsData
        },
        {
            label: 'Closed',
            component: (
                <Grid>
                    <CloseChallengeHolder />
                </Grid>
            ),
            description: 'Please select a challenge from the list to check completion status.',
            type: 'Challenge',
            breadcrumbsData: breadcrumbsData
        }
    ]

    if (challengeContext.loading) return <Loading />;

    return (
        <ChallengeContext.Provider value={{ challengeContext, dispatch }}>
            <DefaultLayout
                title='Challenges'
                type='Challenge'
                description='Earn coins when you win challenges as a team'
                image={getIconChallenge().img_challenge_bg}
            >
                <TabsCategory
                    dataTabsCategory={dataTabsCategory}
                />
            </DefaultLayout>
        </ChallengeContext.Provider >
    );
};

export default Challenge;